import { useTranslations } from "use-intl";

export function useFiltersByMetaTranslations() {
  return useTranslations("FiltersByMeta");
}
